<template>
    <div class="err_report">
        <div class="poster">
            <!-- <img src="@/assets/images/sample/api_poster.jpg" alt=""> -->
            <img :src="getImgUrl()" alt="">
        </div>


        <div class="txt_area">

            <div class="top_right_btn"><a href="javascript:void(0)" @click.prevent="downloadFile()">신청서 다운로드</a></div>

            <ul class="list">
                <li><span class="tit">참여대상 :</span> 전 국민</li>
                <li><span class="tit">제보대상 :</span> 강남구에서 운영 중인 홈페이지, 소셜미디어, 공보물 등에 기재된 공공데이터(행정정보)의 오류사항</li>
                <li><span class="tit">접수기간 :</span> 2023.7.1 ~ 9.30(3개월)</li>
                <li>
                    <p><span class="tit">참여방법</span></p>
                    <p class="txt">- 강남의 잘못된 공공데이터(행정정보)를 찾는다!  <span class="t_red"><b style="color: #FBF267;">※단순 오탈자는 제외</b></span></p>
                    <p class="txt">- 신청서를 다운로드하여 작성한다.</p>
                    <p class="txt">- 담당자 이메일(choihhee@gangnam.go.kr)로 발송한다.</p>
                    <p class="txt">- 접수기간 종료(9.30.) 후 모바일 문화상품권 1만원권을 받는다.</p>
                </li>
            </ul>

            <div class="rbox" style="background: rgb(0 0 0 / 30%)">
                <p>※ 유의사항</p>
                <p>상품권 지급은 인당 1회한이며, 다수가 동일 건으로 접수 시 최초 접수자에게만 지급</p>
            </div>

            <div class="box_tit"><span class="tit">아래와 같은 절차로 처리됩니다.</span></div>

            <div class="box_flow">
                <dl>
                    <dt>신고 접수</dt>
                    <dd>
                        데이터 오류 신고<br class="pc-visible"> 이메일 접수
                    </dd>
                </dl>
                <dl>
                    <dt>담당부서 지정</dt>
                    <dd>
                        담당부서에 <br class="pc-visible"> 신고내역 통보
                    </dd>
                </dl>
                <dl>
                    <dt>담당자 처리</dt>
                    <dd>
                        데이터 오류 <br class="pc-visible"> 확인 및 처리
                    </dd>
                </dl>
                <dl>
                    <dt>처리 결과 안내</dt>
                    <dd>
                        오류 개선 및 <br class="pc-visible"> 결과 안내
                    </dd>
                </dl>
                <dl>
                    <dt>상품권 지급</dt>
                    <dd>
                        참여자에게 모바일 <br class="pc-visible"> 문화상품권 지급
                    </dd>
                </dl>
            </div>

            <p class="mt10">※ 문의 : 디지털도시과 공공데이터팀 3423-7942~3</p>
        </div>
    </div>
</template>

<script>
import { $_WC } from '@/confs/common.const.js';
import {mapGetters} from "vuex";
export default {
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters({
            openApiTab: 'getOpenApiTab',
            selectedOpenApiTab: 'getSelectedOpenApiTab',
            errorReport: 'getErrorReport',
        }),
    },
    watch: {
        errorReport: {
            immediate: true,
            handler(newVal, oldVal) {
            }
        },
    },
    created() {
    },
    methods: {
        downloadFile() {
            if(typeof this.errorReport !== 'undefined' && this.errorReport.length > 0) {
                let data = this.errorReport.filter(d => {
                    return d.val1 == '1';
                });
                let comnFlSqno = data[0].dataFiles[0].comnFlSqno;
                // 서버 저장
                // let url = $_WC.fileDownloadURL + '/viewFile/' + comnFlSqno + '.do';
                
                // db 저장으로 변경해서 attachFileSaveTpc 추가
                let url = $_WC.fileBaseURL + '/viewFile/' + comnFlSqno + '?attachFileSaveTpc=db' ;
                
                // web server -> 정적 파일 로드
                // 업로드경로 /usr/local/.../vision_citizen_web/htdocs/공공데이터(행정정보) 오류신청서.hwpx
                // let url = '/' + '공공데이터(행정정보) 오류신청서.hwpx';
                
                location.href = url;
            }
        },
        getImgUrl() {
            let returnUrl = '';
            if(typeof this.errorReport !== 'undefined' && this.errorReport.length > 0) {
                let data = this.errorReport.filter(d => {
                    return d.val1 == '2';
                });
                let file = data[0].dataFiles;
                returnUrl = $_WC.fileBaseURL + '/image/' + file[0].comnFlSqno + '?attachFileSaveTpc=db'
            }
            return returnUrl;
        },
    },
}
</script>
